import { Injectable, TemplateRef } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class CustomOverlayService {
  public customOverlayDescriptor: CustomOverlayDescriptor = null;

  hold(customDrawer: MatDrawer): void {
    if (customDrawer) {
      this.customOverlayDescriptor = {
        customDrawer,
        template: null
      };
    }
  }

  release(): void {
    this.customOverlayDescriptor = null;
  }
}

export interface CustomOverlayDescriptor {
  customDrawer: MatDrawer;
  template: TemplateRef<any>;
}
